import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M13.286 8.16l-.297.289c-.153.15-.318.278-.489.394V15h5.49l-1.68-4.156a3.647 3.647 0 0 0-.755-1.178 6.39 6.39 0 0 0-1.893-1.331l-.376-.175zM12.5 5.5v1.468c.862-.754 1.284-1.994 1.284-3.2C13.784 1.479 12.531 0 10.591 0 8.643 0 7.384 1.479 7.384 3.769c0 .596.098 1.189.289 1.731H12.5zM11 7H0v11l3-3h8V7zm-3 4.75H3v-1.5h5v1.5z" />
  </svg>
);

export default SvgComponent;
